import { SystemParametersEnum } from '@/shared/constants';
import { PROVEEDOR, SubCategorias } from '../compras';
import { CATEGORYPRODUCT } from '../inventario';
import { Presentacion } from './presentacion.interface';
import { IStockFactorSerie } from './productofactorserie.interface';

export interface IProductoPagingRes {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IDataProducto[];
}

export interface IDataProducto {
  id_producto: string;
  codigo: string;
  numero_referencia: string;
  codigo_secundario: string;
  tipo_producto: string;
  descripcion: string;
  recurrencia_compra: string;
  acepta_negativo: boolean;
  costo_compra: number;
  costo_actual: number;
  costo_promedio: number;
  precios: Precios[];
  marca_producto: string;
  modelo_producto: string;
  urls_imagenes: string[];
  es_productor_factor?: boolean
  es_activo: boolean;
  es_para_venta: boolean;
  es_fibra: boolean;
  es_utp: boolean;
  es_ont: boolean;
  stock_actual: number; //Stock actual de toda la empresa, usado para crear inventariable
  stock_minimo: number;
  stock_maximo: number;
  stock_seguridad: number;
  estado: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
  presentacion: any;
  categoria_producto: string;
  subcategoria_producto: string;
  iva: any;
  unidad_medida: string;
  proveedor: string | null;
  //helper
  stock?: number // Stock actual por ubicacion-producto
  //
  cantidad?: number
  cantidad_recibida?: number
  cantidad_acumulada?: number
  //
  cuentas_contables: any[]

  ///* fk
  presentacion_data: Presentacion
  categoria_producto_data: CATEGORYPRODUCT
  proveedor_data: PROVEEDOR;
  subcategoria_producto_data?: SubCategorias
  cantidad_aprobada?: number | string
  bodega_data?: {
    nombre?: string
  }
  productos_asociados?: string[]
  //aux soliictudingreso
  stockActual?: number;
  //aux revisionSolicitud
  id: string;
  //recepcion-Mercaderia
  ///ordenCompra
  ultimo_precio_compra: string;
  unidad_medida_data: {
    nombre: string
  }
  metros_actuales?: string | number
  usa_metros?: boolean
  metros_base?: number
  contiene_serie: boolean
  service_profile?:string
  //
  cantidad_pendiente?:number 
  cantidad_transferido?:number
}

export interface Precios {
  nombre: string;
  precio: string;
  estado: boolean;

}

export interface IncrementosInterface {
  codigo: string;
  nombre: string;
  valor: number;
}

export const IncrementosEnumChoices: IncrementosInterface[] = [
  { "codigo": "incremento_0", "nombre": "0%", "valor": 0 },
  { "codigo": "incremento_30", "nombre": "30%", "valor": 30 },
  { "codigo": "incremento_40", "nombre": "40%", "valor": 40 },
  { "codigo": "incremento_60", "nombre": "60%", "valor": 60 },
  // { "codigo": "incremento_5", "nombre": "5%", "valor":5 },
  // { "codigo": "incremento_10", "nombre": "10%", "valor":10 },
  // { "codigo": "incremento_15", "nombre": "15%", "valor":15 },
  // { "codigo": "incremento_20", "nombre": "20%", "valor":20 },
  // { "codigo": "incremento_25", "nombre": "25%", "valor":25 },
  // { "codigo": "incremento_35", "nombre": "35%", "valor":35 },
  // { "codigo": "incremento_45", "nombre": "45%", "valor":45 },
  // { "codigo": "incremento_50", "nombre": "50%", "valor":50 },
  // { "codigo": "incremento_55", "nombre": "55%", "valor":55 },
  // { "codigo": "incremento_65", "nombre": "65%", "valor":65 },
  // { "codigo": "incremento_70", "nombre": "70%", "valor":70 },
  // { "codigo": "incremento_75", "nombre": "75%", "valor":75 },
  // { "codigo": "incremento_80", "nombre": "80%", "valor":80 },
  // { "codigo": "incremento_85", "nombre": "85%", "valor":85 },
  // { "codigo": "incremento_90", "nombre": "90%", "valor":90 },
  // { "codigo": "incremento_95", "nombre": "95%", "valor":95 },
  // { "codigo": "incremento_100", "nombre": "100%", "valor":100 }
]



export interface ProductosParam extends Partial<IDataProducto> {
  page?: number;
  page_size?: number;
  //enabled?: boolean;
  codigos?: string;
}

export interface Ingreso_inventario {
  id_ingreso_inventario?: string;
  url_pdf?: string;
  codigo?: string;
  reporte_nombre?: string;
  numero_factura?: string;
  numero_guia_remision?: string;
  orden_compra?: string;
  productos?: ProductoForm[]
}
export interface ProductoForm {
  //requeridos
  codigo: string;
  codigo_secundario?: string;
  //codigo_secundario: string;
  descripcion: string;
  recurrencia_compra: string;
  numero_referencia: string
  costo_compra: number;
  costo_actual: number;
  costo_promedio: number;
  marca_producto: string;
  modelo_producto: string;

  stock_minimo: number;
  stock_maximo: number;
  stock_seguridad: number;
  stock_actual: number
  presentacion?: string;
  categoria_producto: string;
  subcategoria_producto: string;
  iva?: string;
  unidad_medida: string;
  proveedor?: string;

  urls_imagenes?: string[];
  precios?: Precios[];
  observaciones?: string;
  //cuentas_contables?: TreeNode[]
  cuentas_contables?: any[]
  //aux
  precio_1: number;
  precio_2: number;
  precio_3: number;
  //precio_4: number;

  imagen_1?: string;
  imagen_2?: string;
  es_ont?: boolean;

  productos_asociados?: string[]

  //plan_cuenta?: TreeNode[]

  usa_metros?: boolean
  metros_base?: number

  productos_asociados_data?: any[]
  productos_asociados_factor_data?: any[]
  service_profile?:string;
}

///==================================
export interface Productos {
  producto: string;
}
///TODO: Interaz usado como base para los movimientos de inventario (equipos y material), egresos

export enum SerieGeneradoPorENUM {
  TXT = 'TXT',
  EXCEL = 'EXCEL',
  AUTOMATICO = 'AUTOMATICO',
  SELECCION_AUTOMATICO = 'SELECCION_AUTOMATICO',
  SELECCION_MANUAL = 'SELECCION_MANUAL',
}

export enum TipoVentaEnum {
  EQUIPO = 'EQUIPO',
  SERVICIO = 'SERVICIO'
}
export interface MaterialTransferido {

  cantidad: number | string
  codigo: string
  id: string
  descripcion?: string
  producto_data?: Partial<IDataProducto> & {
    codigo: string
    categoria_producto: string
    subcategoria_producto?: string
    descripcion: string
    stock_actual?: number
    //stock_actual: string
    modelo_producto?: string
    marca_producto?: string
    unidad_medida?: string
    stock?: string | number
    precios?: Precios[]
    presentacion?: string
  } | null

  ///* cargar series
  series?: string[];
  file_temporal?: File | null;
  url_archivo?: string | null;
  serie_generado_por?: SerieGeneradoPorENUM | null;
  prefijo?: string | null;
  es_producto_factor?: boolean;
  ///* factibilidad coporativo
  existe_stock?: string
  stock_actual?: string
  existe?: boolean
  //
  categoria_fcorporativa?: string;
  nombre?: string;
  precioUnitario?: number;
  total?: number;
  subtotal?: number;
  ivaValue?: number;
  ivaCode?: string;
  ///* Inventario
  contiene_serie?: boolean
  selected_series?: string[] //elemento auxiliar para guardar todas las series, no se envia al final
  pre_selected_series?: string[] //elemento que sirve para 
  //backup del elemento anterior para no dañar flujos donde se usa, pls, usar selected_series
  series_all?: string[]
  ubicacion_destino?: string
  ubicacion_origen?: string | null

  ///* recepcion de traslado
  cantidad_esperada?: string | number;
  cantidad_acumulada_temp?: number | string

  ///* Egresos
  id_ubicacion_producto?: string
  //cantidad_previamente_despachada?: number
  cantidad_recibida?: number | string /// cantidad que recibe 
  cantidad_acumulada?: number | string  /// suma de la cantidad recibida
  cantidad_aprobada?: number;
  cantidad_a_entregar?: number;
  estado_solicitud?: string | null | undefined
  url_pdf?: string;
  id_ingreso_inventario?: string;
  //*solicitud ingreso
  stockActual?: number;
  //solicitud Egreso
  costo_actual?: number;
  costo_compra?: number;
  costo_promedio?: number;
  //**orden */
  cantidad_pendiente?: number;
  precio_compra?: number | string;
  precio_total?: number,
  ultimo_precio_compra?: string;
  descuento?: string
  cuentas_contables?: any[]
  solicitud_egreso?: string;
  //* orden compra
  //id_producto:string;

  ///* Rubro
  /* cantidadUtilizada?: number;
  selectedSeries?: string[];
  contieneSeries?: boolean; 
  savedSeries?: string[];  */

  incremento?: any
  incrementoCodigo?: any
  precioLibre?: any
  preciosDisponibles?: any[]

  ///* producto asociado
  //es_producto_factor?: boolean;
  producto_factor?: IStockFactorSerie[] | null

  ///* cuadre
  ubicacion?: string;
  pre_selected_serie_cuadre?: PreSeriesCuadre[];
  //registro-factura
  costo?: string,
  cif?: string
  mano_obra_directa?: string;
  mano_obra_indirecta?: string
  iva?: number
  ice?: number
  iva_producto?: string,
  total_producto?: string
  subtotal_descuento?: string
  iva_porcentaje?: string
  ice_producto?: string
  cantidad_previamente_despachada?: number

  ///*equipos adicionales
  cuotas?: string
  tipoVenta?: TipoVentaEnum // EQUIPO, SERVICIO
  metros_actuales?: string | number
  metros_disponibles?: string | number
  usa_metros?: boolean
  ///* productos con metro
  cantidad_metros?: string;
  series_metros?: Record<string, string>
  ///* Nota por serie de la carga manual (reingreso). La llave es la serie en
  ///* MAYUSCULAS, como la normaliza el backend. Destino: Series.observacion.
  observaciones_series?: Record<string, string>
  series_origen?: string[]
  series_destino?: string[]
  name?: string
  //pedido
  cantidad_transferido?:number
}


export interface PreSeriesCuadre {
  id: string
  serie: string
  observacion: string,
  check: boolean
}

export enum CategoriaFCorporativaEnum {
  MATERIALESEQUIPOS = "MATERIALESEQUIPOS",//PARA INSTALACIÓN
  EQUIPOSADICIONALES = "EQUIPOSADICIONALES",//LOS QUE SOLICITA EL CLIENTE
  SERVICIOS_DIGITALES = "SERVICIOS_DIGITALES",//PARA INSTALACIÓN
  SERVICIOSADICIONALES = "SERVICIOSADICIONALES",//LOS CHECKS DE SERVICIOS ADICIONALES
  VALORESPLAN = "VALORESPLAN",//VALORES DEL PLAN Y COSTO INSTALACIÓN
}



export enum EstadoSolicitudTransferencia {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  ABIERTO = 'ABIERTO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  FINALIZADO = 'FINALIZADO'
}

/* export interface IEquipoAdicional {
  descripcion: string;

  numero_cuotas: number;
  cantidad_equipo_adicional: number;
  cantidad: number;
  codigo: string;
  stock_actual: number;
  series: any[];
  precios: {
    estado: boolean;
    nombre: string;
    precio: number;
  }[];
} */

///* Inventariable importar excel
export interface IInventariableExcel {
  codigo: string
  presentacion: string
  proveedor: string
  categoria_producto: string
  subcategoria_producto: string
  unidad_medida: string
  marca_producto: string
  modelo_producto: string
  precio_1: number
  precio_2: number
  precio_3: number
  precio_4: number
  costo_actual: number
  costo_compra: number
  iva: string
  stock_maximo: number
  stock_minimo: number
  stock_seguridad: number
  descripcion: string
  observacion: string

}


export interface IEquipoServicioAdicionales {
  id?: string
  codigo?: string
  cantidad: string | number
  cuotas?: string | number
  tipoVenta?: TipoVentaEnum
  precios?: Precios[];
  descripcion?: string
  slug?: SystemParametersEnum;
  forma_pago?: any;
  series?: string[];

}